var map = {
	"./ABW.svg": 45236,
	"./AFG.svg": 17188,
	"./AGO.svg": 59284,
	"./AIA.svg": 1601,
	"./ALA.svg": 82658,
	"./ALB.svg": 84981,
	"./AND.svg": 81215,
	"./ARE.svg": 3937,
	"./ARG.svg": 10498,
	"./ARM.svg": 23375,
	"./ASM.svg": 74065,
	"./ATA.svg": 81597,
	"./ATF.svg": 45534,
	"./ATG.svg": 1974,
	"./AUS.svg": 49044,
	"./AUT.svg": 27356,
	"./AZE.svg": 8306,
	"./BDI.svg": 30395,
	"./BEL.svg": 93234,
	"./BEN.svg": 45617,
	"./BES.svg": 70078,
	"./BFA.svg": 20828,
	"./BGD.svg": 9758,
	"./BGR.svg": 24008,
	"./BHR.svg": 16549,
	"./BHS.svg": 36076,
	"./BIH.svg": 86096,
	"./BLM.svg": 93419,
	"./BLR.svg": 8316,
	"./BLZ.svg": 31807,
	"./BMU.svg": 27534,
	"./BOL.svg": 78868,
	"./BRA.svg": 50912,
	"./BRB.svg": 98014,
	"./BRN.svg": 14786,
	"./BTN.svg": 4695,
	"./BVT.svg": 54447,
	"./BWA.svg": 76600,
	"./CAF-1.svg": 26954,
	"./CAF.svg": 14442,
	"./CAN.svg": 72319,
	"./CCK.svg": 21943,
	"./CHE.svg": 59309,
	"./CHL.svg": 52499,
	"./CHN.svg": 77930,
	"./CIV.svg": 28267,
	"./CMR.svg": 6661,
	"./COD.svg": 34170,
	"./COG.svg": 63225,
	"./COK.svg": 49020,
	"./COL.svg": 19858,
	"./COM.svg": 37930,
	"./CPV.svg": 81490,
	"./CRI.svg": 51670,
	"./CUB.svg": 80445,
	"./CUW.svg": 49233,
	"./CXR.svg": 55620,
	"./CYM.svg": 56256,
	"./CYP.svg": 29228,
	"./CZE.svg": 76000,
	"./DEU.svg": 5320,
	"./DJI.svg": 50115,
	"./DMA.svg": 12160,
	"./DNK.svg": 1806,
	"./DOM.svg": 59240,
	"./DZA.svg": 4936,
	"./ECU.svg": 53582,
	"./EGY.svg": 41455,
	"./ERI.svg": 87326,
	"./ESH.svg": 20827,
	"./ESP.svg": 12804,
	"./EST.svg": 56834,
	"./ETH.svg": 57474,
	"./FIN.svg": 81817,
	"./FJI.svg": 40102,
	"./FLK.svg": 81076,
	"./FRA.svg": 88087,
	"./FRO.svg": 98725,
	"./FSM.svg": 14877,
	"./GAB.svg": 60086,
	"./GEO.svg": 2976,
	"./GGY.svg": 58521,
	"./GHA.svg": 32412,
	"./GIB.svg": 77013,
	"./GIN.svg": 31839,
	"./GLP.svg": 65885,
	"./GMB.svg": 49594,
	"./GNB.svg": 45255,
	"./GNQ.svg": 28313,
	"./GRB.svg": 12158,
	"./GRC.svg": 90434,
	"./GRD.svg": 23068,
	"./GRL.svg": 85619,
	"./GTM.svg": 45183,
	"./GUF.svg": 30173,
	"./GUM.svg": 25564,
	"./GUY.svg": 29411,
	"./HKG.svg": 12061,
	"./HMD.svg": 99860,
	"./HND.svg": 49047,
	"./HRV.svg": 40573,
	"./HTI.svg": 42192,
	"./HUN.svg": 67533,
	"./IDN.svg": 83143,
	"./IMN.svg": 28232,
	"./IND.svg": 56452,
	"./IOT.svg": 4736,
	"./IRL.svg": 24397,
	"./IRN.svg": 54404,
	"./IRQ.svg": 19875,
	"./ISL.svg": 62032,
	"./ISR.svg": 14359,
	"./ITA.svg": 59009,
	"./JAM.svg": 87983,
	"./JEY.svg": 87355,
	"./JOR.svg": 91147,
	"./JPN.svg": 56127,
	"./KAZ.svg": 6946,
	"./KEN.svg": 46133,
	"./KGZ.svg": 31466,
	"./KHM.svg": 56415,
	"./KIR.svg": 50636,
	"./KNA.svg": 39567,
	"./KOR.svg": 84102,
	"./KWT.svg": 60220,
	"./LAO.svg": 5379,
	"./LBN.svg": 1425,
	"./LBR.svg": 56096,
	"./LBY.svg": 73389,
	"./LCA.svg": 23161,
	"./LIE.svg": 13972,
	"./LKA.svg": 99859,
	"./LSO.svg": 36457,
	"./LTU.svg": 44984,
	"./LUX.svg": 58158,
	"./LVA.svg": 10699,
	"./MAC.svg": 80576,
	"./MAF.svg": 58073,
	"./MAR.svg": 68556,
	"./MCO.svg": 20189,
	"./MDA.svg": 5362,
	"./MDG.svg": 46035,
	"./MDV.svg": 14297,
	"./MEX.svg": 51057,
	"./MHL.svg": 70638,
	"./MKD.svg": 27020,
	"./MLI.svg": 27470,
	"./MLT.svg": 85107,
	"./MNE.svg": 72243,
	"./MNG.svg": 13677,
	"./MNP.svg": 2132,
	"./MNR.svg": 16477,
	"./MOZ.svg": 1877,
	"./MRT.svg": 52066,
	"./MSR.svg": 47717,
	"./MTQ.svg": 84004,
	"./MUS.svg": 37838,
	"./MWI.svg": 17110,
	"./MYS.svg": 49688,
	"./MYT.svg": 44914,
	"./NAM.svg": 50488,
	"./NCL.svg": 65860,
	"./NER.svg": 75891,
	"./NFK.svg": 83454,
	"./NGA.svg": 73499,
	"./NIC.svg": 90924,
	"./NIU.svg": 70630,
	"./NLD.svg": 11586,
	"./NOR.svg": 41427,
	"./NPL.svg": 84746,
	"./NRU.svg": 87340,
	"./NZL.svg": 4628,
	"./OMN.svg": 45705,
	"./PAK.svg": 40525,
	"./PAN.svg": 55986,
	"./PCN.svg": 11946,
	"./PER.svg": 53247,
	"./PHL.svg": 12058,
	"./PLW.svg": 24256,
	"./PNG.svg": 56080,
	"./POL.svg": 80588,
	"./PRI.svg": 52032,
	"./PRK.svg": 85565,
	"./PRT.svg": 53673,
	"./PRY.svg": 33823,
	"./PSE.svg": 74256,
	"./PYF.svg": 64216,
	"./QAT.svg": 78985,
	"./REU.svg": 73941,
	"./ROU.svg": 75602,
	"./RUS.svg": 86979,
	"./RWA.svg": 74684,
	"./SAU.svg": 27025,
	"./SDN.svg": 71999,
	"./SEN.svg": 23981,
	"./SGP.svg": 25308,
	"./SGS.svg": 48577,
	"./SHN.svg": 57720,
	"./SIR.svg": 98512,
	"./SJM.svg": 83999,
	"./SLB.svg": 74419,
	"./SLE.svg": 81495,
	"./SLV.svg": 62420,
	"./SMR.svg": 98050,
	"./SOM.svg": 26463,
	"./SPM.svg": 44262,
	"./SRB.svg": 91230,
	"./SSD.svg": 99352,
	"./STP.svg": 30801,
	"./SUR.svg": 90407,
	"./SVK.svg": 62922,
	"./SVN.svg": 58030,
	"./SWE.svg": 89348,
	"./SWZ.svg": 49279,
	"./SXM.svg": 77622,
	"./SYC.svg": 71935,
	"./TCA.svg": 68718,
	"./TCD.svg": 75706,
	"./TGO.svg": 53307,
	"./THA.svg": 7391,
	"./TJK.svg": 12828,
	"./TKL.svg": 44090,
	"./TKM.svg": 40203,
	"./TLS.svg": 66576,
	"./TON.svg": 9213,
	"./TTO.svg": 65612,
	"./TUK.svg": 10883,
	"./TUN.svg": 19783,
	"./TUV.svg": 77797,
	"./TWN.svg": 70737,
	"./TZA.svg": 8447,
	"./UGA.svg": 14443,
	"./UKR.svg": 75289,
	"./UMI.svg": 26769,
	"./URY.svg": 22977,
	"./USA.svg": 74741,
	"./UZB.svg": 77536,
	"./VAT.svg": 41210,
	"./VCT.svg": 25332,
	"./VEN.svg": 22533,
	"./VGB.svg": 44169,
	"./VIR.svg": 40325,
	"./VNM.svg": 3520,
	"./VUT.svg": 82421,
	"./WLF.svg": 74704,
	"./WSM.svg": 64909,
	"./XKX.svg": 94712,
	"./YEM.svg": 40065,
	"./ZAP.svg": 19934,
	"./ZMB.svg": 14399,
	"./ZWE.svg": 17942,
	"assets/icons/Flags/ABW.svg": 45236,
	"assets/icons/Flags/AFG.svg": 17188,
	"assets/icons/Flags/AGO.svg": 59284,
	"assets/icons/Flags/AIA.svg": 1601,
	"assets/icons/Flags/ALA.svg": 82658,
	"assets/icons/Flags/ALB.svg": 84981,
	"assets/icons/Flags/AND.svg": 81215,
	"assets/icons/Flags/ARE.svg": 3937,
	"assets/icons/Flags/ARG.svg": 10498,
	"assets/icons/Flags/ARM.svg": 23375,
	"assets/icons/Flags/ASM.svg": 74065,
	"assets/icons/Flags/ATA.svg": 81597,
	"assets/icons/Flags/ATF.svg": 45534,
	"assets/icons/Flags/ATG.svg": 1974,
	"assets/icons/Flags/AUS.svg": 49044,
	"assets/icons/Flags/AUT.svg": 27356,
	"assets/icons/Flags/AZE.svg": 8306,
	"assets/icons/Flags/BDI.svg": 30395,
	"assets/icons/Flags/BEL.svg": 93234,
	"assets/icons/Flags/BEN.svg": 45617,
	"assets/icons/Flags/BES.svg": 70078,
	"assets/icons/Flags/BFA.svg": 20828,
	"assets/icons/Flags/BGD.svg": 9758,
	"assets/icons/Flags/BGR.svg": 24008,
	"assets/icons/Flags/BHR.svg": 16549,
	"assets/icons/Flags/BHS.svg": 36076,
	"assets/icons/Flags/BIH.svg": 86096,
	"assets/icons/Flags/BLM.svg": 93419,
	"assets/icons/Flags/BLR.svg": 8316,
	"assets/icons/Flags/BLZ.svg": 31807,
	"assets/icons/Flags/BMU.svg": 27534,
	"assets/icons/Flags/BOL.svg": 78868,
	"assets/icons/Flags/BRA.svg": 50912,
	"assets/icons/Flags/BRB.svg": 98014,
	"assets/icons/Flags/BRN.svg": 14786,
	"assets/icons/Flags/BTN.svg": 4695,
	"assets/icons/Flags/BVT.svg": 54447,
	"assets/icons/Flags/BWA.svg": 76600,
	"assets/icons/Flags/CAF-1.svg": 26954,
	"assets/icons/Flags/CAF.svg": 14442,
	"assets/icons/Flags/CAN.svg": 72319,
	"assets/icons/Flags/CCK.svg": 21943,
	"assets/icons/Flags/CHE.svg": 59309,
	"assets/icons/Flags/CHL.svg": 52499,
	"assets/icons/Flags/CHN.svg": 77930,
	"assets/icons/Flags/CIV.svg": 28267,
	"assets/icons/Flags/CMR.svg": 6661,
	"assets/icons/Flags/COD.svg": 34170,
	"assets/icons/Flags/COG.svg": 63225,
	"assets/icons/Flags/COK.svg": 49020,
	"assets/icons/Flags/COL.svg": 19858,
	"assets/icons/Flags/COM.svg": 37930,
	"assets/icons/Flags/CPV.svg": 81490,
	"assets/icons/Flags/CRI.svg": 51670,
	"assets/icons/Flags/CUB.svg": 80445,
	"assets/icons/Flags/CUW.svg": 49233,
	"assets/icons/Flags/CXR.svg": 55620,
	"assets/icons/Flags/CYM.svg": 56256,
	"assets/icons/Flags/CYP.svg": 29228,
	"assets/icons/Flags/CZE.svg": 76000,
	"assets/icons/Flags/DEU.svg": 5320,
	"assets/icons/Flags/DJI.svg": 50115,
	"assets/icons/Flags/DMA.svg": 12160,
	"assets/icons/Flags/DNK.svg": 1806,
	"assets/icons/Flags/DOM.svg": 59240,
	"assets/icons/Flags/DZA.svg": 4936,
	"assets/icons/Flags/ECU.svg": 53582,
	"assets/icons/Flags/EGY.svg": 41455,
	"assets/icons/Flags/ERI.svg": 87326,
	"assets/icons/Flags/ESH.svg": 20827,
	"assets/icons/Flags/ESP.svg": 12804,
	"assets/icons/Flags/EST.svg": 56834,
	"assets/icons/Flags/ETH.svg": 57474,
	"assets/icons/Flags/FIN.svg": 81817,
	"assets/icons/Flags/FJI.svg": 40102,
	"assets/icons/Flags/FLK.svg": 81076,
	"assets/icons/Flags/FRA.svg": 88087,
	"assets/icons/Flags/FRO.svg": 98725,
	"assets/icons/Flags/FSM.svg": 14877,
	"assets/icons/Flags/GAB.svg": 60086,
	"assets/icons/Flags/GEO.svg": 2976,
	"assets/icons/Flags/GGY.svg": 58521,
	"assets/icons/Flags/GHA.svg": 32412,
	"assets/icons/Flags/GIB.svg": 77013,
	"assets/icons/Flags/GIN.svg": 31839,
	"assets/icons/Flags/GLP.svg": 65885,
	"assets/icons/Flags/GMB.svg": 49594,
	"assets/icons/Flags/GNB.svg": 45255,
	"assets/icons/Flags/GNQ.svg": 28313,
	"assets/icons/Flags/GRB.svg": 12158,
	"assets/icons/Flags/GRC.svg": 90434,
	"assets/icons/Flags/GRD.svg": 23068,
	"assets/icons/Flags/GRL.svg": 85619,
	"assets/icons/Flags/GTM.svg": 45183,
	"assets/icons/Flags/GUF.svg": 30173,
	"assets/icons/Flags/GUM.svg": 25564,
	"assets/icons/Flags/GUY.svg": 29411,
	"assets/icons/Flags/HKG.svg": 12061,
	"assets/icons/Flags/HMD.svg": 99860,
	"assets/icons/Flags/HND.svg": 49047,
	"assets/icons/Flags/HRV.svg": 40573,
	"assets/icons/Flags/HTI.svg": 42192,
	"assets/icons/Flags/HUN.svg": 67533,
	"assets/icons/Flags/IDN.svg": 83143,
	"assets/icons/Flags/IMN.svg": 28232,
	"assets/icons/Flags/IND.svg": 56452,
	"assets/icons/Flags/IOT.svg": 4736,
	"assets/icons/Flags/IRL.svg": 24397,
	"assets/icons/Flags/IRN.svg": 54404,
	"assets/icons/Flags/IRQ.svg": 19875,
	"assets/icons/Flags/ISL.svg": 62032,
	"assets/icons/Flags/ISR.svg": 14359,
	"assets/icons/Flags/ITA.svg": 59009,
	"assets/icons/Flags/JAM.svg": 87983,
	"assets/icons/Flags/JEY.svg": 87355,
	"assets/icons/Flags/JOR.svg": 91147,
	"assets/icons/Flags/JPN.svg": 56127,
	"assets/icons/Flags/KAZ.svg": 6946,
	"assets/icons/Flags/KEN.svg": 46133,
	"assets/icons/Flags/KGZ.svg": 31466,
	"assets/icons/Flags/KHM.svg": 56415,
	"assets/icons/Flags/KIR.svg": 50636,
	"assets/icons/Flags/KNA.svg": 39567,
	"assets/icons/Flags/KOR.svg": 84102,
	"assets/icons/Flags/KWT.svg": 60220,
	"assets/icons/Flags/LAO.svg": 5379,
	"assets/icons/Flags/LBN.svg": 1425,
	"assets/icons/Flags/LBR.svg": 56096,
	"assets/icons/Flags/LBY.svg": 73389,
	"assets/icons/Flags/LCA.svg": 23161,
	"assets/icons/Flags/LIE.svg": 13972,
	"assets/icons/Flags/LKA.svg": 99859,
	"assets/icons/Flags/LSO.svg": 36457,
	"assets/icons/Flags/LTU.svg": 44984,
	"assets/icons/Flags/LUX.svg": 58158,
	"assets/icons/Flags/LVA.svg": 10699,
	"assets/icons/Flags/MAC.svg": 80576,
	"assets/icons/Flags/MAF.svg": 58073,
	"assets/icons/Flags/MAR.svg": 68556,
	"assets/icons/Flags/MCO.svg": 20189,
	"assets/icons/Flags/MDA.svg": 5362,
	"assets/icons/Flags/MDG.svg": 46035,
	"assets/icons/Flags/MDV.svg": 14297,
	"assets/icons/Flags/MEX.svg": 51057,
	"assets/icons/Flags/MHL.svg": 70638,
	"assets/icons/Flags/MKD.svg": 27020,
	"assets/icons/Flags/MLI.svg": 27470,
	"assets/icons/Flags/MLT.svg": 85107,
	"assets/icons/Flags/MNE.svg": 72243,
	"assets/icons/Flags/MNG.svg": 13677,
	"assets/icons/Flags/MNP.svg": 2132,
	"assets/icons/Flags/MNR.svg": 16477,
	"assets/icons/Flags/MOZ.svg": 1877,
	"assets/icons/Flags/MRT.svg": 52066,
	"assets/icons/Flags/MSR.svg": 47717,
	"assets/icons/Flags/MTQ.svg": 84004,
	"assets/icons/Flags/MUS.svg": 37838,
	"assets/icons/Flags/MWI.svg": 17110,
	"assets/icons/Flags/MYS.svg": 49688,
	"assets/icons/Flags/MYT.svg": 44914,
	"assets/icons/Flags/NAM.svg": 50488,
	"assets/icons/Flags/NCL.svg": 65860,
	"assets/icons/Flags/NER.svg": 75891,
	"assets/icons/Flags/NFK.svg": 83454,
	"assets/icons/Flags/NGA.svg": 73499,
	"assets/icons/Flags/NIC.svg": 90924,
	"assets/icons/Flags/NIU.svg": 70630,
	"assets/icons/Flags/NLD.svg": 11586,
	"assets/icons/Flags/NOR.svg": 41427,
	"assets/icons/Flags/NPL.svg": 84746,
	"assets/icons/Flags/NRU.svg": 87340,
	"assets/icons/Flags/NZL.svg": 4628,
	"assets/icons/Flags/OMN.svg": 45705,
	"assets/icons/Flags/PAK.svg": 40525,
	"assets/icons/Flags/PAN.svg": 55986,
	"assets/icons/Flags/PCN.svg": 11946,
	"assets/icons/Flags/PER.svg": 53247,
	"assets/icons/Flags/PHL.svg": 12058,
	"assets/icons/Flags/PLW.svg": 24256,
	"assets/icons/Flags/PNG.svg": 56080,
	"assets/icons/Flags/POL.svg": 80588,
	"assets/icons/Flags/PRI.svg": 52032,
	"assets/icons/Flags/PRK.svg": 85565,
	"assets/icons/Flags/PRT.svg": 53673,
	"assets/icons/Flags/PRY.svg": 33823,
	"assets/icons/Flags/PSE.svg": 74256,
	"assets/icons/Flags/PYF.svg": 64216,
	"assets/icons/Flags/QAT.svg": 78985,
	"assets/icons/Flags/REU.svg": 73941,
	"assets/icons/Flags/ROU.svg": 75602,
	"assets/icons/Flags/RUS.svg": 86979,
	"assets/icons/Flags/RWA.svg": 74684,
	"assets/icons/Flags/SAU.svg": 27025,
	"assets/icons/Flags/SDN.svg": 71999,
	"assets/icons/Flags/SEN.svg": 23981,
	"assets/icons/Flags/SGP.svg": 25308,
	"assets/icons/Flags/SGS.svg": 48577,
	"assets/icons/Flags/SHN.svg": 57720,
	"assets/icons/Flags/SIR.svg": 98512,
	"assets/icons/Flags/SJM.svg": 83999,
	"assets/icons/Flags/SLB.svg": 74419,
	"assets/icons/Flags/SLE.svg": 81495,
	"assets/icons/Flags/SLV.svg": 62420,
	"assets/icons/Flags/SMR.svg": 98050,
	"assets/icons/Flags/SOM.svg": 26463,
	"assets/icons/Flags/SPM.svg": 44262,
	"assets/icons/Flags/SRB.svg": 91230,
	"assets/icons/Flags/SSD.svg": 99352,
	"assets/icons/Flags/STP.svg": 30801,
	"assets/icons/Flags/SUR.svg": 90407,
	"assets/icons/Flags/SVK.svg": 62922,
	"assets/icons/Flags/SVN.svg": 58030,
	"assets/icons/Flags/SWE.svg": 89348,
	"assets/icons/Flags/SWZ.svg": 49279,
	"assets/icons/Flags/SXM.svg": 77622,
	"assets/icons/Flags/SYC.svg": 71935,
	"assets/icons/Flags/TCA.svg": 68718,
	"assets/icons/Flags/TCD.svg": 75706,
	"assets/icons/Flags/TGO.svg": 53307,
	"assets/icons/Flags/THA.svg": 7391,
	"assets/icons/Flags/TJK.svg": 12828,
	"assets/icons/Flags/TKL.svg": 44090,
	"assets/icons/Flags/TKM.svg": 40203,
	"assets/icons/Flags/TLS.svg": 66576,
	"assets/icons/Flags/TON.svg": 9213,
	"assets/icons/Flags/TTO.svg": 65612,
	"assets/icons/Flags/TUK.svg": 10883,
	"assets/icons/Flags/TUN.svg": 19783,
	"assets/icons/Flags/TUV.svg": 77797,
	"assets/icons/Flags/TWN.svg": 70737,
	"assets/icons/Flags/TZA.svg": 8447,
	"assets/icons/Flags/UGA.svg": 14443,
	"assets/icons/Flags/UKR.svg": 75289,
	"assets/icons/Flags/UMI.svg": 26769,
	"assets/icons/Flags/URY.svg": 22977,
	"assets/icons/Flags/USA.svg": 74741,
	"assets/icons/Flags/UZB.svg": 77536,
	"assets/icons/Flags/VAT.svg": 41210,
	"assets/icons/Flags/VCT.svg": 25332,
	"assets/icons/Flags/VEN.svg": 22533,
	"assets/icons/Flags/VGB.svg": 44169,
	"assets/icons/Flags/VIR.svg": 40325,
	"assets/icons/Flags/VNM.svg": 3520,
	"assets/icons/Flags/VUT.svg": 82421,
	"assets/icons/Flags/WLF.svg": 74704,
	"assets/icons/Flags/WSM.svg": 64909,
	"assets/icons/Flags/XKX.svg": 94712,
	"assets/icons/Flags/YEM.svg": 40065,
	"assets/icons/Flags/ZAP.svg": 19934,
	"assets/icons/Flags/ZMB.svg": 14399,
	"assets/icons/Flags/ZWE.svg": 17942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70314;